import { Locale } from 'modules/domains';
import { useState } from 'react';
import { NavTabTrigger, TabsContent } from 'ui/tabsGroup';
import { CardContent } from './CardContent';
import { FullWidthNavTabsList, FullWidthTabsGroup } from './Styled';

export type TabbedCardContentProps = {
  locales: Locale[];
};

export const TabbedCardContent = ({ locales }: TabbedCardContentProps) => {
  const [selectedLocale, setSelectedLocale] = useState<Locale>(locales[0]);
  return (
    <FullWidthTabsGroup value={selectedLocale.tag} data-test="quick-replies-tabs">
      <FullWidthNavTabsList>
        {locales.map((locale) => (
          <NavTabTrigger
            key={locale.tag}
            data-test={`quick-replies-tab-${locale.tag}-${selectedLocale.tag === locale.tag ? 'active' : 'inactive'}`}
            value={locale.tag}
            onClick={() => setSelectedLocale(locale)}
          >
            {locale.languageName}
          </NavTabTrigger>
        ))}
      </FullWidthNavTabsList>
      {locales.map((locale) => (
        <TabsContent
          key={locale.tag}
          data-test={`quick-replies-tab-content-${locale.tag}`}
          value={locale.tag}
        >
          <CardContent locale={locale} />
        </TabsContent>
      ))}
    </FullWidthTabsGroup>
  );
};
